export default __webpack_public_path__ + "static/2-c87350567ad978f32a29db81ef4daa76.jpeg";